import React from 'react'

function SvgRemboursement() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path d="M17.6387 10.2896V5.9481C17.6387 5.14429 16.9858 4.49268 16.1804 4.49268H3.54158C2.73617 4.49268 2.08325 5.14429 2.08325 5.94809V12.7401C2.08325 13.5439 2.73617 14.1955 3.54158 14.1955H8.72673" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.0418 11.4463L12.292 14.1907M12.292 14.1907L14.8565 16.7501M12.292 14.1907L17.9165 14.1908" stroke="#202020" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.08325 6.19061C2.08322 5.11885 2.95378 4.25 4.02769 4.25H15.694C16.7678 4.25 17.6384 5.11814 17.6384 6.18985M2.56899 7.64586H17.1522M5.48564 11.0418H7.91618" stroke="#202020" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default SvgRemboursement